const Links = {
	STREAM_STICKERS_HOME: 'https://www.streamstickers.com',
};

const GTAG_ID = 'G-3XYH9MZM21';

const StickerType = {
	CUSTOM: 'CUSTOM',
	REWARD: 'REWARD',
	POWER: 'POWER',
	TTS: 'TTS',
	GLOBAL: 'GLOBAL',
	FAVORITE: 'FAVORITE',
	PLACEMENT: 'PLACEMENT',
	SUB_ONLY: 'SUB_ONLY',
};

const TtsDisplayMode = {
	STICKER: 'STICKER',
	CO_HOST: 'CO_HOST',
};

const GlobalStickerSize = {
	SMALL: 0,
	MEDIUM: 1,
	LARGE: 2,
};

const GTAG_KEY = {
	DEV: 'G-CF51FTNW7L',
	PROD: 'G-T2PEFC4GG7',
};

module.exports = { Links, GTAG_ID, StickerType, TtsDisplayMode, GlobalStickerSize, GTAG_KEY };
